function _blobToString(blob, encoding, onload) {
  let reader = new FileReader();
  reader.onload = function(event){
    onload(reader.result)
  };
  reader.readAsText(blob, encoding);
}

function WebSocketWrapper(url) {
  this.url = url;
  this.isClose = false;
  this.map = {};
  this.ws = this.__createWebSocket(url);
}
WebSocketWrapper.prototype.addEventListener = function(name, callback, data) {
  let listeners;
  if (this.map.hasOwnProperty(name)) {
    listeners = this.map[name];
  } else {
    listeners = new Map();
    this.map[name] = listeners;
  }

  let cid = uuid.v4();

  listeners.set(cid, {cid: cid, callback: callback, data: data});

  this.ws.send(JSON.stringify({code: 1, name: name, cid: cid, data: data ? data : null}));

  return cid;
};

WebSocketWrapper.prototype.removeEventListener = function(name, cid) {
  if (this.map.hasOwnProperty(name)) {
    let listeners = this.map[name];
    listeners.delete(cid);
    if (listeners.size < 1) {
      delete this.map[name];
    }
  }
  this.ws.send(JSON.stringify({code: 2, name: name, cid: cid}));
};
WebSocketWrapper.prototype.close = function() {
  if (!this.isClose) {
    this.isClose = true;
    this.ws.close();
  }
};
WebSocketWrapper.prototype.__onopen = function() {
  console.log("ws onopen: " + this.url);
  for (let name in this.map) {
    let listeners = this.map[name]
    listeners.forEach(item => {
      this.ws.send(JSON.stringify({code: 1, name: name, cid: item.cid, data: item.data ? item.data : null}));
    })
  }

  this.__login(this.ws);
};
WebSocketWrapper.prototype.__login = function(ws) {
  if (ws !== this.ws) {
    return;
  }
  const token = window.session.get(window.sessionKeys.TOKEN);
  if (token) {
    let data = JSON.stringify({code: 0, token: token});
    ws.send(data);
  } else {
    setTimeout(() =>{this.__login(ws)}, 1000)
  }
};
WebSocketWrapper.prototype.__onmessage = function (msg) {
  let data = msg.data;
  if (data.constructor===Blob) {
    _blobToString(data, "utf-8", (str)=> {
      this.__onmessage2(JSON.parse(str));
    });
  } else if (typeof(data) === "string" || data.constructor===String) {
    this.__onmessage2(JSON.parse(data));
  } else {
    this.__onmessage2(data);
  }
};
WebSocketWrapper.prototype.__onmessage2 = function(obj) {
  if(obj.type === 'msg') {
    let name = obj.name;
    let msg = obj.msg;
    let cids = obj.cids;
    let listeners = this.map[name];
    for (let cid of cids) {
      if (listeners.has(cid)) {
        let listener = listeners.get(cid);
        let obj2 = JSON.parse(msg);
        listener.callback(obj2);
      }
    }
  }
};
WebSocketWrapper.prototype.__onclose = function() {
  console.log("ws onclose: " + this.url);
  if (!this.isClose) {
    this.__reconnect();
  }
};
WebSocketWrapper.prototype.__reconnect = function() {
  if (this.ws) {
    this.ws.onopen = null;
    this.ws.onmessage = null;
    this.ws.onclose = null;
    delete this.ws;
  }
  this.ws = this.__createWebSocket(this.url);
};
WebSocketWrapper.prototype.__createWebSocket = function(url) {
  let ws = new WebSocket(url);
  ws.onopen = this.__onopen.bind(this);
  ws.onmessage = this.__onmessage.bind(this);
  ws.onclose = this.__onclose.bind(this);
  return ws;
};

export default WebSocketWrapper;



// WEBPACK FOOTER //
// ./src/apis/ents.js